module.exports = __webpack_public_path__ + "media/DisplayGallery.2856cf91.svg";